import React from "react";
import { Badge } from "reactstrap"; // or from your UI library

const statusMap = {
  unpaid: { color: "danger", label: "Unpaid" },
  paid: { color: "success", label: "Paid" },
  draft: { color: "secondary", label: "Draft" },
  cancelled: { color: "dark", label: "Cancelled" },
  partly_paid: { color: "warning", label: "Partly Paid" },
};

const StatusBadge = ({ status }) => {
  const normalizedStatus = status?.toLowerCase();
  const { color, label } = statusMap[normalizedStatus] || {
    color: "light",
    label: status || "Unknown",
  };

  return (
    <Badge className="badge-dot" color={color}>
      {label}
    </Badge>
  );
};

export default StatusBadge;
